import React, { useContext, useState } from 'react';
import { Show } from '../../components';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { defaultQueryOptions } from '../../utils/defaultQueryOptions';
import { ContanierSection, Loading, PageError } from '../../uiComponents/common';
import { WelletContext } from '../../context/wellet/welletContext';
import { useSelector } from 'react-redux';
// import { getMembershipLevel } from '../services';
import CardCheck from '../../uiComponents/common/cardCheck/cardCheck';
import { Modallevels, ModalDelete } from './components';
import { getMembershipLevel } from '../../services';
import AffiliateCard from './components/affiliateCard';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Award } from 'lucide-react';

const Loyalty = ({ mode }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'screens.memberships.levels' });
  const { t: tGeneric } = useTranslation('translation', { keyPrefix: 'generic' });
  const organization = useSelector((state) => state.app.selectedOrganization);
  const welletContext = useContext(WelletContext, organization.marketId);
  const [level, setLevel] = useState({});
  const [openDelete, setOpenDelete] = useState(null);

  const levelsQuery = useQuery({
    queryKey: ['levels', organization.marketId, mode],
    queryFn: () => getMembershipLevel(welletContext, organization.marketId),
    ...defaultQueryOptions,
  });

  return (
    <>
      {/* <PageHeader title={t('title')} /> */}
      <Show>
        <Show.When isTrue={levelsQuery.isFetching}>
          <Loading />
        </Show.When>
        <Show.When isTrue={levelsQuery.isError}>
          <PageError />
        </Show.When>
        <Show.Else>
          <ContanierSection maxWidth='1200px'>
            <Show.When isTrue={mode === 'INDEPENDENT'}>
              {levelsQuery?.data?.data
                ?.filter((l) => l.schemeType === 'FIXED' && l.affiliateType === 'INDEPENDENT')
                ?.map((level) => (
                  <AffiliateCard t={t} level={level} key={level.id} />
                ))}
            </Show.When>
            <Show.When isTrue={mode === 'CONCIERGE'}>
              {levelsQuery?.data?.data
                ?.filter((l) => l.schemeType === 'FIXED' && l.affiliateType === 'CONCIERGE')
                ?.map((level) => (
                  <AffiliateCard t={t} level={level} key={level.id} />
                ))}
            </Show.When>
            <Show.When isTrue={mode === 'CONCIERGE' || mode === 'INTERNAL_STAFF'}>
              <Card className='tw-p-3'>
                <CardHeader>
                  <div className='tw-flex tw-items-center tw-gap-2'>
                    <Award className='tw-h-5 tw-w-5' />
                    <CardTitle className='tw-text-base'>
                      {t('form.title', {
                        name:
                          mode === 'CONCIERGE'
                            ? tGeneric('concierges')
                            : tGeneric('collaborators'),
                      })}
                    </CardTitle>
                  </div>
                  <CardDescription>{t('form.subtitle')}</CardDescription>
                </CardHeader>
                <CardContent>
                  {' '}
                  {levelsQuery?.data?.data
                    ?.filter((l) => l.schemeType !== 'FIXED')
                    ?.filter((l) => l.affiliateType === mode)
                    ?.map((level, index) => (
                      <CardCheck
                        className={index !== 0 ? 'mt-2' : ''}
                        key={level.id}
                        title={level.name}
                        check={level.isActive}
                        onClick={() => setLevel(level)}
                        subtitle={t('targetPoints', { targetPoints: level.targetPoints })}
                        showDelete={true}
                        percentage={level.defaultCommissionPercentage}
                        rpPercentage={level.defaultCommissionPercentageLevel2}
                        onDeleteClick={() => setOpenDelete(level)}
                      />
                    ))}
                  <Modallevels
                    mode={mode}
                    callback={levelsQuery.refetch}
                    level={level}
                    setLevel={setLevel}
                  />
                  <ModalDelete
                    refetchLevels={levelsQuery.refetch}
                    open={openDelete}
                    setOpen={setOpenDelete}
                    mode={mode}
                  />
                </CardContent>
              </Card>{' '}
            </Show.When>
          </ContanierSection>
        </Show.Else>
      </Show>
    </>
  );
};

export default Loyalty;
